export const MealTypes = [
    "BREAKFAST",
    "SIDE",
    "LUNCH",
    "DINNER",
    "SNACKS",
    "DRINKS",
];

export const Days = [
  'MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY','SUNDAY'
];

export const S3_BASE_URL = "https://resources.daily-meal.com";